import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import {addEditHRTicketReady} from '../redux/hr'
import apiService from '../services/apiservices'
import { headerDataUpdate, buildNumberUpdate } from '../../../redux/user'
import * as Constants from '../../../common/constants'
import  {ValidatePhone} from '../../../common/ValidationFunctions/CommonValidation'


import {Employees,Issues} from '../../../common/DropDowns/index'

//import * as Helpers from '../../../common/helpers'
import {EntityType} from '../../../common/DropDowns/index'

function filterUnwantedData(employeeData) {
    let data = {}
    if (employeeData && employeeData.data && employeeData.data) {
        data = employeeData.data
    }

    let newData = {}
            newData.id = data.id ? data.id : ""
            newData.name = data.name ? data.name : ""
            newData.email = data.email ? data.email : ""
            newData.code = data.code ? data.code : ""
            newData.mobile = data.mobile ? data.mobile : ""
            newData.status = data.status ? data.status : ""
            newData.status_class = data.status ? data.status.replace(" ","") : ""
            newData.city_name="NA"
            newData.work_location_type=data.work_location_type ? data.work_location_type : "NA"
            newData.work_location="NA"

            if(data.city && data.city.name){
                newData.city_name=data.city.name
            }


            if(data.kitchen_work_location && data.kitchen_work_location.name && data.work_location_type==="Kitchen"){
                newData.work_location=data.kitchen_work_location.name
            }

            if(data.office_work_location && data.office_work_location.name && data.work_location_type!=="Kitchen"){
                newData.work_location=data.office_work_location.name
            }
    
    return newData
}



class AddEditHRTicket extends Component {

    constructor() {
        super()
        this.state = {
            
            bodyHeight: "0px",

            brandName:null,
            employeeId:null,
            type:null,
            issue:null,
            phone:null,
            issuerRemarks:null,
            assignedId:null,
            hrRemarks:null,

            selectedHRTicket :{},
            employeeData:{},
            editFlag:false,
            showEmployeeData:false,
  
            
            employeeIdErrorText: false,
            employeeIdErrorData: '',

            phoneErrorText: false,
            phoneErrorData: '',

            typeText: false,
            typeData: '',

            issueText: false,
            issueData: '',

            issuerRemarksText: false,
            issuerRemarksData: '',

            assignedIdText: false,
            assignedIdData: '',


            hrRemarksText: false,
            hrRemarksData: '',

            
            subTitle: Constants.ADD_HR_TICKET
            
        }
        this.isComponentStillMounted = true

        this.phoneComponent = null
        this.phoneSection = null

        this.brandNameComponent = null
        this.brandNameSection = null

        this.employeeIdComponent = null
        this.employeeIdSection = null

        this.typeComponent = null
        this.typeSection = null

        this.issueComponent = null
        this.issueSection = null


        this.issuerRemarksComponent = null
        this.issuerRemarksSection = null

        this.assignedIdComponent = null
        this.assignedIdSection = null

        this.hrRemarksComponent = null
        this.hrRemarksSection = null



        
    }

    componentWillMount() {
        this.isComponentStillMounted = true
        this.props.dispatch(addEditHRTicketReady(true))
        
        if(this.props.hr && this.props.hr.hrTicketsSelectedId && this.props.hr.hrTicketsSelectedId !== null){
            this.props.dispatch(headerDataUpdate(Constants.EDIT_HR_TICKET))
            this.setState({subTitle: Constants.EDIT_HR_TICKET,editFlag:true})
            this.getHRTicketDetailsById(this.props.hr.hrTicketsSelectedId);
        }else{
            this.props.dispatch(headerDataUpdate(Constants.ADD_HR_TICKET))
        }
        
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    componentDidMount() {
        this.brandNameSection = ReactDOM.findDOMNode(this.refs.brandNameSection)
        this.phoneSection = ReactDOM.findDOMNode(this.refs.phoneSection)
        this.employeeIdSection = ReactDOM.findDOMNode(this.refs.employeeIdSection)  
        this.typeSection = ReactDOM.findDOMNode(this.refs.typeSection)   
        this.issueSection = ReactDOM.findDOMNode(this.refs.issueSection)     
        this.issuerRemarksSection = ReactDOM.findDOMNode(this.refs.issuerRemarksSection)   
        this.assignedIdSection = ReactDOM.findDOMNode(this.refs.assignedIdSection)    
        this.hrRemarksSection = ReactDOM.findDOMNode(this.refs.hrRemarksSection)    

    }


    getHRTicketDetailsById = (hrTicketsSelectedId) =>{

         this.props.dispatch(addEditHRTicketReady(false))
        
            apiService.getHRTicketDetailsById(hrTicketsSelectedId)
                .then(responseData => {
                    this.props.dispatch(addEditHRTicketReady(true))
                    if (this.isComponentStillMounted && responseData.status === "SUCCESS") {
                        this.setState({
                            selectedHRTicket:responseData.data
                        })

                            let employeeData={}
                            employeeData.id = responseData.data.employee.id ? responseData.data.employee.id : ""
                            employeeData.name = responseData.data.employee.name ? responseData.data.employee.name : ""
                            employeeData.email = responseData.data.employee.email ? responseData.data.employee.email : ""
                            employeeData.code = responseData.data.employee.code ? responseData.data.employee.code : ""
                            employeeData.mobile = responseData.data.contact_no ? responseData.data.contact_no : ""
                            employeeData.city_name="NA"
                            employeeData.work_location_type=responseData.data.employee.work_location_type ? responseData.data.employee.work_location_type : "NA"

                            employeeData.status=responseData.data.employee.status ? responseData.data.employee.status : "NA"
                            employeeData.status_class=responseData.data.employee.status ? responseData.data.employee.status.replace(" ","") : "NA"
                            employeeData.work_location="NA"

                            if(responseData.data.employee.city && responseData.data.employee.city.name){
                                employeeData.city_name=responseData.data.employee.city.name
                            }


                            if(responseData.data.employee.kitchen_work_location && responseData.data.employee.kitchen_work_location.name && responseData.data.employee.work_location_type==="KITCHEN"){
                                employeeData.work_location=responseData.data.employee.kitchen_work_location.name
                            }

                            if(responseData.data.employee.office_work_location && responseData.data.employee.office_work_location.name && responseData.data.employee.work_location_type==="OFFICE"){
                                employeeData.work_location=responseData.data.employee.office_work_location.name
                            }

                            this.setState({
                                employeeData: employeeData
                            });
                    }
                })
                .catch(err => {
                    console.log("Error data: ", err)
                    this.props.dispatch(addEditHRTicketReady(true))
                    this.dialog.show({
                        title: "Server respond with Error data",
                        body: 'Getting brand details got interrupted',
                        actions: [
                            Dialog.OKAction(() => {
                                this.props.history.goBack()
                            })
                        ],
                        onHide: (dialog) => {
                            dialog.hide()
                            this.props.history.goBack()
                        }
                    })
                })
    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 120) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 100) + "px",
            })
        }
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

mandateValidation = (inputName, type) => {
    let inputComponent = inputName + "Component"
    let inputErrorText = inputName + "ErrorText"
    let inputErrorData = inputName + "ErrorData"
    let inputSection = inputName + "Section"
    let errorMsg = Constants.NON_VALID_MSG_INPUT
    if (Constants.FORM_SELECT === type) {
        errorMsg = Constants.NON_VALID_MSG_SELECT
        console.log("input name :::", inputName)
        console.log("input data :::", this.state[inputName])
    }
    if (this.state[inputName] === null || this.state[inputName] === undefined || this.state[inputName] === "") {
        this[inputComponent].focus()
        this.setState({
            [inputErrorText]: true,
            [inputErrorData]: errorMsg
        })
        this[inputSection].className = this[inputSection].className.replace(" has-error", "")
        this[inputSection].className += " has-error"
        return {
            status: false,
            value: ''
        }
    }
    return {
        status: true
    }
}
    onSaveClick = () => {
        let data ={}
        this.props.dispatch(addEditHRTicketReady(false))

        if(this.state.editFlag){

             let hrRemarksObject = this.mandateValidation("hrRemarks",Constants.FORM_INPUT)
            if (hrRemarksObject.status) {
                data.hr_remarks = this.state.hrRemarks
            } else {
                this.props.dispatch(addEditHRTicketReady(true))
                return
            }
                    
             data.status="CLOSED"

            let apiPayloadData=data
            
            apiService.editHRTicket(apiPayloadData,this.state.selectedHRTicket.id)
                .then(responseData => {                     
                        if (responseData.status === "SUCCESS") {
                            this.props.dispatch(addEditHRTicketReady(true))
                            this.props.history.push("/dashboard/hr/hrtickets/list")
                        } else {

                            this.props.dispatch(addEditHRTicketReady(true))
                            this.dialog.show({
                                title: "Alert",
                                body: responseData.reason ? responseData.reason : "",
                                actions: [
                                    Dialog.OKAction(() => {
                                    })
                                ],
                            })
                        }
                    
                })
                .catch(err => {
                    this.props.dispatch(addEditHRTicketReady(true))
                    console.error("Error data: ", err)
                   alert("exception"+ err);
                })

        }else{

        let phoneObject = this.mandateValidation("phone", Constants.FORM_INPUT)
        if (phoneObject.status) {
            
            if(ValidatePhone(this.phoneComponent.value)){
                data.contact_no = this.phoneComponent.value
            }else{
                this.dialog.show({
                    title: "Error",
                    body: "Please enter valid 10 digit phone number.",
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })

                this["phoneSection"].className = this["phoneSection"].className.replace(" has-error", "")
                this["phoneSection"].className += " has-error"
                this["phoneComponent"].focus()
                this.props.dispatch(addEditHRTicketReady(true))
                return
            }
        } else {
             this.props.dispatch(addEditHRTicketReady(true))
            return
        }


        let typeObject = this.mandateValidation("type", Constants.FORM_SELECT)
            if (typeObject.status) {
                data.type = this.typeComponent.value
            } else {
                 this.props.dispatch(addEditHRTicketReady(true))
                return
            }



            let issueObject = this.mandateValidation("issue", Constants.FORM_SELECT)
            if (issueObject.status) {
                data.issue_id = this.issueComponent.value
            } else {
                this.props.dispatch(addEditHRTicketReady(true))
                return
            }

            let issuerRemarksObject = this.mandateValidation("issuerRemarks",Constants.FORM_INPUT)
            if (issuerRemarksObject.status) {
                data.issue_remarks = this.state.issuerRemarks
            } else {
                this.props.dispatch(addEditHRTicketReady(true))
                return
            }

             let assignedIdObject = this.mandateValidation("assignedId", Constants.FORM_SELECT)
            if (assignedIdObject.status) {
                data.assigned_id = this.assignedIdComponent.value
            } else {
                this.props.dispatch(addEditHRTicketReady(true))
                return
            }

                    
             data.employee_id=this.state.employeeData.id

        let apiPayloadData=data
        
        apiService.addHRTicket(apiPayloadData)
            .then(responseData => {
                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(addEditHRTicketReady(true))
                        this.props.history.push("/dashboard/hr/hrtickets/list")
                    } else {

                        this.props.dispatch(addEditHRTicketReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(addEditHRTicketReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })

            }
        
    }

     entityTypeChange = (data) => {
    this.typeComponent.value=data.value
        this.setState({
            type :data.value,
            typeErrorText: false,
            typeErrorData: ''
        })
        this.typeSection.className= this.typeSection.className.replace(" has-error", "")
    }


   issueChange = (data) => {
    this.issueComponent.value=data.value
        this.setState({
            issue :data.value,
            issueErrorText: false,
            issueErrorData: ''
        })
        this.issueSection.className= this.issueSection.className.replace(" has-error", "")
    }




getEmployeeById = (id) => {
    this.props.dispatch(addEditHRTicketReady(false))
    apiService.getEmployeeById(id)
        .then(responseData => {
            this.props.dispatch(addEditHRTicketReady(true))
            if (responseData.status === "SUCCESS") {
                if (responseData && responseData.data) {    
                      let filterData=filterUnwantedData(responseData)
                   
                    this.setState({
                        employeeData: filterData,
                        showEmployeeData:true,
                        phone:responseData.data.mobile
                        })

                    this.phoneComponent.value=this.state.employeeData.mobile

                }

            }


        })
        .catch(err => {
            console.error("Error data: ", err)
             this.props.dispatch(addEditHRTicketReady(true))
        })
}


  employeeChange= (data) => {
    this.employeeIdComponent.value=data.value
        this.setState({
            employeeId :data.value,
            employeeIdErrorText: false,
            employeeIdErrorData: '',
            showEmployeeData:false
        })
        this.employeeIdSection.className= this.employeeIdSection.className.replace(" has-error", "")

        if(data.value!=="" && data.value!==undefined){
            this.setState({
                showEmployeeData:false 
            });
            this.getEmployeeById(data.value)
        }
    }

    hrEmployeeChange= (data) => {
    this.assignedIdComponent.value=data.value
        this.setState({
            assignedId :data.value,
            assignedIdErrorText: false,
            assignedIdErrorData: '',
        })
        this.assignedIdSection.className= this.assignedIdSection.className.replace(" has-error", "")

    }




    integerValidation = (value) => {
        if (/\D/.test(value)) {
            return true
        } else {
            return false
        }
    }

    onCancelClick = () => {
        this.props.history.goBack()
    }

    statusChange= (data) => {
            this.statusComponent.value=data.value
            this.setState({
                status :data.value,
                statusErrorText: false,
                statusErrorData: ''
            })
            this.statusSection.className= this.statusSection.className.replace(" has-error", "")
        }

    
    render() {
        return (
            <div className="line-item-edit">
              <div className="col-md-12" style={{ "paddingBottom" : "1%"}}>
                    <a href="" 
                        onClick={(e) => {e.preventDefault() 
                                    this.props.history.goBack()}}> 
                            <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                    </a>
                </div>
                <Dialog ref={el => this.dialog = el} />
                <section className="content">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" style={{ height: this.state.bodyHeight,overflow: "auto"}}>
                            <div className="box box-info" style={{ borderTop: "0px" }}>
                                <div className="box-header with-border">
                                {(() => {
                                      if(this.state.editFlag){
                                      return (
                                                <h3 className="box-title" style={{ fontWeight: 600 }}>Edit HR Ticket</h3>
                                            )
                                        }else{
                                            return (
                                             <h3 className="box-title" style={{ fontWeight: 600 }}>Create HR Ticket</h3>
                                            )
                                        }
                                  })()}
                                  
                                </div>
                                <div className="form-horizontal">
                                 {(() => {
                                      if(!this.state.editFlag){
                                          return (
                                        
                                            
                                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                                <div className="col-md-12 col-sm-12 col-xs-12">
                                                    <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                           this.employeeIdSection = el}>
                                                           <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select Employee *</label>
                                                            <div className="col-sm-9" ref={el =>
                                                              this.employeeIdComponent = el}>
                                                              <Employees type="hr_ticket" employeeChange={this.employeeChange} selectedValue={this.state.employeeId} />
                                                              <span className="help-block" style={{ display: this.state.employeeIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                              {this.state.employeeIdErrorData}
                                                              </span>
                                                            </div>
                                                        </div>
                                                     </div>                                          
                                                </div>

                                    </div>

                                        )
                                    }
                                      })()}

                                      {(() => {
                                                if(this.state.showEmployeeData || this.state.editFlag){
                                                    return(

                                                    <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                                            <div className="box-header with-border">
                                                               <h3 className="box-title" style={{ fontWeight: 600 }}>Employee Details</h3>
                                                            </div>
                                                        
                                             <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: "1%"}}>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Name :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Employee Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.code}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Email Id :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.email}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Mobile :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.mobile}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>City :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.city_name}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className="form-group">
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Work Location :</label>
                                                        <div className="col-sm-7">
                                                                {this.state.employeeData.work_location}
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                             <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="col-md-4 col-sm-12 col-xs-12">
                                                    <div className={"form-group employee_status_"+this.state.employeeData.status_class+""}>
                                                        <label className="col-sm-5 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Status :</label>
                                                        <div className="col-sm-7">
                                                               <strong> {this.state.employeeData.status}</strong>
                                                            
                                                        </div>
                                                    </div>
                                                </div>

                                                </div>

                                                    </div>

                                                        )
                                                    }
                                            })()}

                                             {(() => {
                                                if(this.state.showEmployeeData){
                                                    return(

                                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                                            <div className="box-header with-border">
                                                               <h3 className="box-title" style={{ fontWeight: 600 }}>Ticket Details</h3>
                                                            </div>
                                                        
                                             <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: "1%"}}>
                                                  <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el =>
                                                             this.phoneSection = el}>
                                                             <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Contact No *</label>
                                                             <div className="col-sm-9">
                                                                <input className="form-control" placeholder="Enter Mobile No" type="number" ref={el => this.phoneComponent = el}
                                                                onChange={(e) => {e.preventDefault() 
                                                                this.keyedInputChange("phone")}} />
                                                                <span className="help-block" style={{ display: this.state.phoneErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                                {this.state.phoneErrorData}
                                                                </span>
                                                             </div>
                                                          </div>
                                                    </div>
                                             </div>


                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.typeSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type *</label>
                                                    <div className="col-sm-9" ref={el => this.typeComponent = el}>
                                                       
                                                    <EntityType entityTypeChange={this.entityTypeChange} selectedValue={this.state.type} type="HR_TICKETS" />
                                                        <span className="help-block"style={{display: this.state.typeErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.typeErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                         <div className="col-md-12 col-sm-12 col-xs-12">

                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group" ref={el => this.issueSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Issue *</label>
                                                    <div className="col-sm-9" ref={el => this.issueComponent = el}>
                                                       
                                                    <Issues issueChange={this.issueChange} selectedValue={this.state.issue} />


                                                        <span className="help-block"style={{display: this.state.issueErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.issueErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>


                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                            <div className="form-group" ref={el => this.issuerRemarksSection = el}>
                                                    <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Issuer Remarks *</label>
                                                    <div className="col-sm-9">
                                                        <textarea className="form-control" placeholder="Enter issuerRemarks" type="text" ref={el => this.issuerRemarksComponent = el}
                                                            onChange={(e) => {e.preventDefault() 
                                                            this.keyedInputChange("issuerRemarks")}} />
                                                        <span className="help-block"style={{display: this.state.issuerRemarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                            {this.state.issuerRemarksErrorData}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>



                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                             <div className="col-md-6 col-sm-12 col-xs-12">
                                                    <div className="form-group" ref={el =>
                                                       this.assignedIdSection = el}>
                                                       <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Assign HR *</label>
                                                        <div className="col-sm-9" ref={el =>
                                                          this.assignedIdComponent = el}>
                                                          <Employees type="hr_list" employeeChange={this.hrEmployeeChange} selectedValue={this.state.assignedId} />
                                                          <span className="help-block" style={{ display: this.state.assignedIdErrorText ? 'block' : 'none', marginTop: '0px', marginBottom: '0px' }}>
                                                          {this.state.assignedIdErrorData}
                                                          </span>
                                                        </div>
                                                    </div>
                                                 </div>  

                                                 </div>  


                                              </div>

                                                        )
                                                    }
                                            })()}

                                     {(() => {
                                                if(this.state.editFlag){
                                                    return(

                                                    
                                            <div className="box-body" style={{ marginTop: "20px", marginBottom: "20px" }}>

                                                            <div className="box-header with-border">
                                                               <h3 className="box-title" style={{ fontWeight: 600 }}>Ticket Details</h3>
                                                            </div>
                                                        
                                                 <div className="col-md-12 col-sm-12 col-xs-12" style={{marginTop: "1%"}}>
                                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group">
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Contact No :</label>
                                                                 <div className="col-sm-9">
                                                                    {(() => {
                                                                        if(this.state.selectedHRTicket.contact_no && this.state.selectedHRTicket.contact_no!=="" && this.state.selectedHRTicket.contact_no!==undefined){
                                                                            return(
                                                                                <p>{this.state.selectedHRTicket.contact_no}</p>
                                                                            )
                                                                        }else{
                                                                            return(
                                                                                <p>NA</p>
                                                                            )
                                                                        }
                                                                    })()}                                         
                                                                 </div>
                                                             </div>

                                                        </div>
                                                    </div>

                                                     <div className="col-md-12 col-sm-12 col-xs-12" >
                                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group">
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Type :</label>
                                                                 <div className="col-sm-9">
                                                                    {(() => {
                                                                        if(this.state.selectedHRTicket.type && this.state.selectedHRTicket.type!=="" && this.state.selectedHRTicket.type!==undefined){
                                                                            return(
                                                                                <p>{this.state.selectedHRTicket.type}</p>
                                                                            )
                                                                        }else{
                                                                            return(
                                                                                <p>NA</p>
                                                                            )
                                                                        }
                                                                    })()}                                         
                                                                 </div>
                                                             </div>

                                                        </div>
                                                    </div>

                                                     <div className="col-md-12 col-sm-12 col-xs-12" >
                                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group">
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Issue :</label>
                                                                 <div className="col-sm-9">
                                                                    {(() => {
                                                                        if(this.state.selectedHRTicket.issue && this.state.selectedHRTicket.issue.name && this.state.selectedHRTicket.issue.name!=="" && this.state.selectedHRTicket.issue.name!==undefined){
                                                                            return(
                                                                                <p>{this.state.selectedHRTicket.issue.name}</p>
                                                                            )
                                                                        }else{
                                                                            return(
                                                                                <p>NA</p>
                                                                            )
                                                                        }
                                                                    })()}                                         
                                                                 </div>
                                                             </div>

                                                        </div>
                                                    </div>



                                                     <div className="col-md-12 col-sm-12 col-xs-12" >
                                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                                            <div className="form-group">
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Issuer Remarks :</label>
                                                                 <div className="col-sm-9">
                                                                    {(() => {
                                                                        if(this.state.selectedHRTicket.issue_remarks && this.state.selectedHRTicket.issue_remarks!=="" && this.state.selectedHRTicket.issue_remarks!==undefined){
                                                                            return(
                                                                                <p>{this.state.selectedHRTicket.issue_remarks}</p>
                                                                            )
                                                                        }else{
                                                                            return(
                                                                                <p>NA</p>
                                                                            )
                                                                        }
                                                                    })()}                                         
                                                                 </div>
                                                             </div>

                                                        </div>
                                                    </div>


                                                     <div className="col-md-12 col-sm-12 col-xs-12">
                                                         <div className="col-md-6 col-sm-12 col-xs-12">
                                                        <div className="form-group" ref={el => this.hrRemarksSection = el}>
                                                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>HR Remarks *</label>
                                                                <div className="col-sm-9">
                                                                    <textarea className="form-control" placeholder="Type HR remarks...." type="text" ref={el => this.hrRemarksComponent = el}
                                                                        onChange={(e) => {e.preventDefault() 
                                                                        this.keyedInputChange("hrRemarks")}} />
                                                                    <span className="help-block"style={{display: this.state.hrRemarksErrorText ? 'block' : 'none',marginTop: '0px', marginBottom: '0px' }}>
                                                                        {this.state.hrRemarksErrorData}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>





                                                    </div>


                                                    )
                                                }
                                             })()}


                                    <div className="box-footer">
                                        <button
                                            className="btn btn-default"
                                            onClick={(e) => {
                                                e.preventDefault()
                                                this.onCancelClick()
                                            }}>
                                            Cancel
                                        </button>

                                         {(() => {
                                                if(this.state.editFlag){
                                                    return(

                                                    <button
                                                        className="btn btn-info pull-right"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.onSaveClick()
                                                        }}>
                                                        Close Ticket
                                                    </button>

                                                    )
                                                }else{
                                                     return(

                                                    <button
                                                        className="btn btn-info pull-right"
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            this.onSaveClick()
                                                        }}>
                                                        Create Ticket
                                                    </button>

                                                    )
                                                }
                                             })()}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }

    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }

}
function mapStateToProps(state) {
    return {
        hr: state.hr,
        user: state.user,
    }
}

export default connect(mapStateToProps)(withRouter(AddEditHRTicket))


// WEBPACK FOOTER //
// ./src/modules/HR/Components/AddEditHRTicket.js